export default function GmtToLocal(gmtString) {
  gmtString = new Date(gmtString).toString().substring(4, 24);
  if (gmtString === "Dec 31 0000 19:03:58") gmtString = "N/A";
  return gmtString;
}
